import React from "react";
import { motion } from "framer-motion";

const MotionWrap = (Component, classNames) =>
  function HOC() {
    const variant = {
      hidden: { y: 100, opacity: 0 },
      show: { y: 0, opacity: 1, transition: { duraion: 0.5 } },
    };
    return (
      <motion.div
        initial="hidden"
        whileInView="show"
        variants={variant}
        className={`${classNames} app__flex`}
      >
        <Component />
      </motion.div>
    );
  };

export default MotionWrap;
